export const Z_INDEX_NAV_ITEM_BACKGROUND = -1;
export const Z_INDEX_BASE = 0;
export const Z_INDEX_DROPDOWN = 1;
export const Z_INDEX_MAIN_NAV_ITEM = 1;
export const Z_INDEX_NAVIGATION_MENU = 3;
export const Z_INDEX_SEARCH_MENU = 2;
export const Z_INDEX_HEADER_TEXT = 0;
export const Z_INDEX_NAV_WRAPPER = 100;
export const Z_INDEX_DIALOG = 101;
